// extracted by mini-css-extract-plugin
module.exports = {"cursor":"TermsOfServicePage_cursor__5O_8y","heading":"TermsOfServicePage_heading__Y0t0L","content":"TermsOfServicePage_content__1LxC4"};